module.exports = __webpack_public_path__ + "static/media/43_B.e7edf07c.png";